// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","menuTooltip":"ComponentMenu_menuTooltip__31nyN","searchInput":"ComponentMenu_searchInput__2sOAg"};